/*
 * ATTENTION: The "eval" devtool has been used (maybe by default in mode: "development").
 * This devtool is neither made for production nor for readable output files.
 * It uses "eval()" calls to create a separate source file in the browser devtools.
 * If you are trying to read the output file, select a different devtool (https://webpack.js.org/configuration/devtool/)
 * or disable the default devtool with "devtool: false".
 * If you are looking for production-ready output files, see mode: "production" (https://webpack.js.org/configuration/mode/).
 */
(self["webpackChunkempty_project"] = self["webpackChunkempty_project"] || []).push([["src_js_utils_seo_js"],{

/***/ "./src/js/utils/seo.js":
/*!*****************************!*\
  !*** ./src/js/utils/seo.js ***!
  \*****************************/
/***/ (() => {

eval("window.addEventListener('load', function () {\n  document.querySelectorAll('[data-href64]').forEach(function (el) {\n    var href64 = el.getAttribute('data-href64');\n    var href = window.atob(href64);\n    el.addEventListener('click', function (e) {\n      if (e.ctrlKey || e.metaKey) {\n        var newWindow = window.open(decodeURIComponent(href), '_blank');\n        newWindow.focus();\n      } else if (e.shiftKey) {\n        window.open(decodeURIComponent(href));\n      } else {\n        document.location.href = decodeURIComponent(href);\n      }\n      e.preventDefault();\n    });\n  });\n});\n\n//# sourceURL=webpack://empty-project/./src/js/utils/seo.js?");

/***/ })

}]);